export const UPLOAD_ITEM_VALIDATING_TOOLTIP_COPY = `We're validating your data, this process may take some time. After validation, assets will be imported into the system.`;
